<template>
    <div>
        <Navbar />
        <PageTitle />
        <LogIn />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../LogIn/PageTitle'
import LogIn from '../LogIn/LogIn'
import FooterTop from '../Layout/FooterTop'
import FooterBottom from '../Layout/FooterBottom'

export default {
    name: 'LogInPage',
    components: {
        Navbar,
        PageTitle,
        LogIn,
        FooterTop,
        FooterBottom,
    }
}
</script>
